// This file is generated by i18next-parser-workspaces, do not modify manually.
// Run `$ npx i18next-parser-workspaces` to update this file

export const NAMESPACES = ['account', 'common', 'cookiebanner', 'demo', 'epg', 'error', 'menu', 'search', 'user', 'video'];
